import {
  Box,
  Typography,
  IconButton,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { DateTime } from "luxon";
import { Close } from "@mui/icons-material";

export const DayDialogTitle = ({
  selectedDay,
  handleCloseDayDialog,
}: {
  selectedDay: string;
  handleCloseDayDialog: () => void;
}) => {
  const theme = useTheme();
  return (
    <DialogTitle
      sx={{
        p: 0,
        background: `linear-gradient(to right, ${theme.palette.grey[100]}, ${theme.palette.grey[50]})`,
        borderBottom: `2px solid #aaa`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 2, sm: 2.5 },
          py: { xs: 1.25, sm: 1.5 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            fontSize: { xs: "0.9rem", sm: "1rem" },
          }}
        >
          {selectedDay &&
            DateTime.fromISO(selectedDay).toLocaleString({
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
        </Typography>
        <IconButton onClick={handleCloseDayDialog} size="small">
          <Close />
        </IconButton>
      </Box>
    </DialogTitle>
  );
};
